import { useEffect, useState } from 'react';

const telegram = window.Telegram?.WebApp;

export const useTelegram = () => {
  const [user, setUser] = useState(null);
  const [initData, setInitData] = useState('');

  useEffect(() => {
    if (telegram) {
      telegram.ready();
      // Expand to full height
      telegram.expand();
      
      if (telegram.initDataUnsafe?.user) {
        setUser(telegram.initDataUnsafe.user);
      }
      if (telegram.initData) {
        setInitData(telegram.initData);
      }
    }
  }, []);

  const close = () => {
    telegram?.close();
  };

  return {
    tg: telegram,
    user,
    initData,
    close,
    isTelegram: !!telegram?.initData, // Simple check if running in TG
  };
};
